import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'

const Names = {
  fr: 'coupon-perdu',
  en: 'coupon-lost'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Retrouvez votre numéro de coupon',
      en: 'Find your coupon number'
    },
    description: {
      fr: 'Consultez cette page pour connaître les différentes façons de retrouver votre numéro de coupon.',
      en: 'Consult this page for information on how to find you coupon number.'
    }
  },
  props: (route) => ({ query: route.query }),
  component: () => import('@page/couponLost/CouponLost.vue'),
  beforeEnter: async (to, from, next) => {
    // Add anything you want to be executed before enter the route
    next()
  }
}

export { Config }
